import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const STOCK_LOCATIONS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('STOCK_LOCATIONS');
export const STOCK_LOCATIONS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	STOCK_LOCATIONS_CRUD_ACTION_CONSTANTS
);
